import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/20/solid";

type Props = {
	isClosed: boolean;
};

export function MonthlyClosingState(props: Props) {
	return props.isClosed ? (
		<span className="flex items-center gap-1 text-success-700">
			<CheckCircleIcon className="size-4" />geschlossen
		</span>
	) : (
		<span className="flex items-center gap-1 text-danger-700">
			<XCircleIcon className="size-4" />offen
		</span>
	);
}
